"use client";

import ConsultationLandingPage from "./ConsultationLandingPage";
import { genericConsultationLandingConfig } from "./consultationLandingConfigs";

export default function ConsultationsClient() {
  return <ConsultationLandingPage config={genericConsultationLandingConfig} />;
}
